module.exports = __webpack_public_path__ + "img/so.ba052f96.svg";